import { AxiosError } from 'axios';
import { enqueueSnackbar } from 'notistack';

export const createErrorHandler = (preferredMessage?: string) => (err?: AxiosError<any>) => {
  enqueueSnackbar(err?.response?.data?.message || preferredMessage || 'Something went wrong. Please try again later.', {
    variant: [400, 401, 404, 500].includes(+(err?.code || 0)) ? 'error' : 'warning',
  });
};
